<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="vuesax/linear/chart">
    <g id="chart">
      <path
        id="Vector"
        d="M1.66663 18.3335L18.3333 18.3335"
        stroke="#212529"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_2"
        d="M8.125 3.33317L8.125 18.3332H11.875L11.875 3.33317C11.875 2.4165 11.5 1.6665 10.375 1.6665L9.625 1.6665C8.5 1.6665 8.125 2.4165 8.125 3.33317Z"
        stroke="#212529"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_3"
        d="M2.5 8.33317L2.5 18.3332H5.83333L5.83333 8.33317C5.83333 7.4165 5.5 6.6665 4.5 6.6665H3.83333C2.83333 6.6665 2.5 7.4165 2.5 8.33317Z"
        stroke="#212529"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_4"
        d="M14.1666 12.5002L14.1666 18.3335H17.5V12.5002C17.5 11.5835 17.1666 10.8335 16.1666 10.8335H15.5C14.5 10.8335 14.1666 11.5835 14.1666 12.5002Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </g>
</svg>
